import { useRef, useLayoutEffect } from 'react';

// Tracks the most recently rendered orgId in a ref so an async response tied to a
// stale orgId (captured earlier in a closure) can detect the org has since changed
// and skip applying itself, instead of overwriting the newly-selected org's data.
// useLayoutEffect (not a render-body assignment) keeps the update out of the render
// phase while still landing before any microtask (a .then()/.catch() callback) can
// observe it — render phase must stay pure for React's concurrent features.
export default function useLatestOrgId(orgId) {
  const ref = useRef(orgId);
  useLayoutEffect(() => {
    ref.current = orgId;
  }, [orgId]);
  return ref;
}
